export default __webpack_public_path__ + "static/media/Datorsal8.bf1d7926.jpeg";